module.exports = __webpack_public_path__ + "media/site_templates/www.gascooktopinstallation.com.au/images/our_services_3-68492e3dcc2fc8aa5314d7e622d488c9.jpg";